import Modal from "../../common/components/Modal";
import BasicButton from "../../common/components/BasicButton";
import { ExclamationTriangleIcon } from "@heroicons/react/24/outline";

interface InfohubDeleteModalProps {
  isOpen: boolean;
  onClose: () => void;
  onDelete: () => Promise<void>;
  deleteLoading: boolean;
  documentName?: string;
}

function InfohubDeleteModal({
  isOpen,
  onClose,
  onDelete,
  deleteLoading,
  documentName,
}: InfohubDeleteModalProps) {
  return (
    <Modal
      title="문서 삭제"
      open={isOpen}
      onClose={onClose}
      width="500px"
      height="auto"
    >
      <div className="flex w-full flex-col gap-6 pb-2">
        <div className="flex flex-col items-center justify-center gap-4">
          <ExclamationTriangleIcon className="h-12 w-12 text-red-500" />
          {documentName && (
            <p className="text-center text-lg font-semibold text-gray-900">
              "{documentName}"
            </p>
          )}
          <div className="text-center">
            <p className="text-lg text-gray-700">
              삭제된 문서는 복구할 수 없습니다.
            </p>
            <p className="text-lg text-gray-700">정말 삭제하시겠습니까?</p>
          </div>
          <p className="text-sm text-gray-500">
            삭제된 문서는 더 이상 답변 출처로 사용되지 않습니다.
          </p>
        </div>
        <div className="flex justify-center gap-2">
          <BasicButton
            text="취소"
            onClick={onClose}
            variant="outlined"
            disabled={deleteLoading}
          />
          <BasicButton
            text="삭제"
            onClick={onDelete}
            variant="error"
            loading={deleteLoading}
          />
        </div>
      </div>
    </Modal>
  );
}

export default InfohubDeleteModal;
